import { createBrowserRouter } from "react-router-dom"

import { RootProvidersErrorRoute } from "@/app/router/root-providers-error-route"
import { createTenantRootChildren } from "@/app/router/route-groups"
import { RootProvidersRoute } from "@/app/router/root-providers-route"

const routerBasename = "/"

export const appRouter = createBrowserRouter(
  [
    {
      element: <RootProvidersRoute />,
      errorElement: <RootProvidersErrorRoute />,
      children: createTenantRootChildren(),
    },
  ],
  {
    basename: routerBasename,
  },
)
